var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PropertySelect',{staticClass:"property-alarm-new",attrs:{"prop-model":_vm.propModel,"is-read-only":false,"value":null,"show-icon":_vm.showIcon},on:{"update:value":_vm.addReminderFromSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }